import { MintButtonWrapper } from './MintButton.css';

type MintButtonProps = {
  handleMintClick: () => void;
};

export default function MintButton({ handleMintClick }: MintButtonProps) {
  return <MintButtonWrapper onClick={handleMintClick}>MINT</MintButtonWrapper>;
}
